<template>
  <bs-modal
    :name="`update-both-${issueid}`"
    :ok-title="$t('javascript.yes_update_both')"
    :cancel-title="$t('javascript.cancel')"
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"

    :value="value"
    @input="$emit('input', $event)"
  >
    <form class="form-inline">
      <p> {{ $t('javascript.you_moved_proposal_n_secret') }} </p>
      <p>
        <strong v-html="$t('javascript.are_you_sure_update_both', {proposal})"></strong>
      </p>

      <div class="alert alert-danger size-12" role="alert">
        <i class="fa fa-exclamation-triangle"></i>
        {{ $t('javascript.other_party_shown_new_value') }}
      </div>
    </form>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "update-both",
    props: [
      'proposal',     // Number
      'value',        // Boolean
      'issueid' // Number
    ],
    components: {BsModal}
  }
</script>
